import React, { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Select, Button } from "antd";
import "./evaluationsFilterSidebarForm.scss";
import useQCEStore from "../../store/qce.store";

function EvaluationsBankFilterSidebarForm({qhjid,ev_id,evalDesc,localQDesc ,localQHanlder,localFilterViewHandler
                                       ,filterHandler}) {
    const navigate = useNavigate();
    const [selectedSkill, setSkill] = useState(['all']); 
    const [selectedAssessmentType, setAssessmentType] = useState(['all']); 
    const [selectedLevel, setLevel] = useState("all"); 
    const [selectedSource, setSelectedSource] = useState("all"); 

    const getSkillList = evalDesc.skillarray?.map((skillItem,idx) => {                                                    
          return { value: skillItem.skill.toUpperCase(), label: skillItem.skill.toUpperCase()}      
      })  
    
    useEffect(() => {
       
    }, []);

    const aaList = [
      {"value": "all", "label": "All"}
    ] 
    const CombinedSills = [...getSkillList, ...aaList]
    
  const handleSelect = (value, type) =>{
    console.log("selecteD",value,type)
    if(type == 'SKILL'){
      setSkill([...value])
    }else if(type =='ASSESSMENTTYPE'){
     setAssessmentType([...value])
    }else if (type == 'LEVEL'){
      setLevel(value)
    }else {
      setSelectedSource(value)
    }
  }
  const handleFilterReset= () => {
    filterHandler("all",["all"],"all",["all"]) 
    localFilterViewHandler("normal")
  }
  const handleFormSubmitFilter = (values) => { 
    filterHandler(selectedLevel,selectedAssessmentType,selectedSource,selectedSkill) 
    localFilterViewHandler("filtered")                
  };

  return (
    <div className="resume-filter-sidebar-wrapper">
        <Form
          className="jd-creation-form"
          name="bank-filter-form"
          justify="start"
          layout="vertical"
          autoComplete="off"
          onFinish={handleFormSubmitFilter}
        >
        <Form.Item
          className="jd-creation-field-item"
          label="Skills"
          name="skills"
        >
          <Select
            className="jd-creation-input" 
            mode="multiple"
            allowClear                            
            placeholder= {selectedSkill}
            onChange={(val)=>handleSelect(val,'SKILL')}
            options={CombinedSills}
          />                         
        </Form.Item>
        <Form.Item
          className="jd-creation-field-item"
          label="Assessment Type"
          name="assessmenttype"
        >          
          <Select
            className="jd-creation-input" 
            mode="multiple"
            allowClear                           
            placeholder={selectedAssessmentType}
            onChange={(val)=>handleSelect(val,'ASSESSMENTTYPE')}
            options={[
                      { value: 'Programming', label: 'Programming' },
                      { value: 'Domain', label: 'Domain' },
                      { value: 'Framework', label: 'Framework' },
                      { value: 'Role', label: 'Role' },
                      { value: 'Exp', label: 'Exp' }, 
                      { value: 'all', label: 'All' },  
                      ]}
          />                         
        </Form.Item>
        <Form.Item
          className="jd-creation-field-item"
          label="Level"
          name="level"
        >
          <Select
            className="jd-creation-input"                          
            placeholder={selectedLevel}
            onChange={(val)=>handleSelect(val,'LEVEL')}
            options={[
                      { value: 'Entry', label: 'Entry' }, 
                      { value: 'Intermediate', label: 'Intermediate' },             
                      { value: 'Expert', label: 'Expert' },
                      { value: 'all', label: 'All' },
                      ]}
          />                         
        </Form.Item>        
        <Form.Item
          className="jd-creation-field-item"
          label="Source"
          name="source"
        >
          <Select
            className="jd-creation-input"                          
            placeholder={selectedSource}
            onChange={(val)=>handleSelect(val,'SOURCE')}
            options={[
                      { value: 'AI Generated', label: 'AI Generated' },              
                      { value: 'Custom', label: 'Custom' },
                      { value: 'all', label: 'All' },
                      ]}
          />                         
        </Form.Item>        
          <Button
              style={{ width: "60%", height: "40px", fontWeight: "600" }}
              type="primary"
              htmlType="submit"
          >
              Update Filter
          </Button>
        </Form>
        <div style={{ marginTop: "30px" }}>
          <Button
                style={{ width: "60%", height: "40px", fontWeight: "600" }}
                onClick={handleFilterReset}
          >
                Reset Filter
          </Button>
        </div>

    </div>
  );
}

export default EvaluationsBankFilterSidebarForm;
